import Icon from '@ant-design/icons';
import React from 'react';
import { ReactComponent as IconSvg } from '../../assets/Settings.svg';

export const Settings = (props: React.ComponentProps<typeof Icon>) => {
  return <Icon component={IconSvg} {...props} />;
};
